import React from "react";
import { Col, ListGroup, Container, Row, Table } from "react-bootstrap";
import Header from "../stories/components/Header.js";
import Image from "../stories/components/Image.js";
import DoDont from "../stories/components/DoDont.js";
import LinkListItem from "../stories/components/LinkListItem";
import FeaturedBlock from "../stories/components/FeaturedBlock";
import ColorTableRow from "../stories/components/ColorTableRow";
import ColorTableHead from "../stories/components/ColorTableHead";
import TypoTableRow from "../stories/components/TypoTableRow";
import TypoTableHead from "../stories/components/TypoTableHead";
import LogoTableRow from "../stories/components/LogoTableRow";
import LogoTableHead from "../stories/components/LogoTableHead";

import {
  LogoAgderPrimaerBokmaalPositivSvg,
  LogoAgderPrimaerBokmaalPositivPng,
  LogoAgderPrimaerBokmaalPositivPdf,
  LogoAgderPrimaerBokmaalNegativSvg,
  LogoAgderPrimaerBokmaalNegativPng,
  LogoAgderPrimaerBokmaalNegativPdf,
  LogoAgderPrimaerBokmaalEngelskPositivSvg,
  LogoAgderPrimaerBokmaalEngelskPositivPng,
  LogoAgderPrimaerBokmaalEngelskPositivPdf,
  LogoAgderPrimaerBokmaalEngelskNegativSvg,
  LogoAgderPrimaerBokmaalEngelskNegativPng,
  LogoAgderPrimaerBokmaalEngelskNegativPdf,
} from "../assets/logo/Agder/exportAgder.js";

export default function ComponentsPage() {
  return (
    <>
      <Container fluid="lg">
        <article>
          <Header
            title="Innholdsmoduler"
            lead="Oversikt over alle innholdsmoduler som kan brukes i profilåndboken"
          />
          <main>
            <Row className="content">
              <Col md={{ span: 8, offset: 2 }}>
                <h2>Overskrift</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum. <a href="/">Les mer om farger</a>
                </p>
                <h3>Underoverskrift</h3>
                <ul>
                  <li>Neil Armstrong</li>
                  <li>Alan Bean</li>
                  <li>Peter Conrad</li>
                  <li>Edgar Mitchell</li>
                  <li>Alan Shepard</li>
                </ul>
                <h4>Mellomtittel</h4>
                <ol>
                  <li>Mix flour, baking powder, sugar, and salt.</li>
                  <li>In another bowl, mix eggs, milk, and oil.</li>
                  <li>Stir both mixtures together.</li>
                  <li>Fill muffin tray 3/4 full.</li>
                  <li>Bake for 20 minutes.</li>
                </ol>
              </Col>
            </Row>
            <Image
              size="small"
              imgUrl="https://via.placeholder.com/400x300?text=Liten"
              alt="Lite bilde"
              caption="Bilde med bildetekst (mulighet for 3 ulike bredder på bildet)"
            />
            <Image
              size="medium"
              imgUrl="https://via.placeholder.com/700x400?text=Medium"
              alt="Medium bilde"
              caption="Bilde med bildetekst (mulighet for 3 ulike bredder på bildet)"
            />
            <Image
              size="large"
              imgUrl="https://via.placeholder.com/1200x500?text=Stor"
              alt="Stort bilde"
              caption="Bilde med bildetekst (mulighet for 3 ulike bredder på bildet)"
            />
            <Row className="my-6">
              <Col md={{ span: 4, offset: 2 }}>
                <ListGroup variant="flush">
                  <LinkListItem
                    title="Statsfolvalteren i Agder"
                    url="/logo-agder"
                  />
                  <LinkListItem
                    title="Statforvalteren i Innlandet"
                    url="/logo-innlandet"
                  />
                  <LinkListItem
                    title="Statforvalteren i Møre og Romsdal"
                    url="/logo-møre-og-romsdal"
                  />
                  <LinkListItem
                    title="Statforvalteren i Nordland"
                    url="/logo-nordland"
                  />
                  <LinkListItem
                    title="Statforvalteren i Oslo og Viken"
                    url="/logo-oslo-og-viken"
                  />
                </ListGroup>
              </Col>
              <Col md={{ span: 4 }}>
                <ListGroup variant="flush">
                  <LinkListItem
                    title="Statforvalteren i Rogaland"
                    url="/logo-rogaland"
                  />
                  <LinkListItem
                    title="Statforvalteren i Trøndelag"
                    url="/logo-trøndelag"
                  />
                  <LinkListItem
                    title="Statforvalteren i Troms og Finnmark"
                    url="/logo-troms-og-finnmark"
                  />
                  <LinkListItem
                    title="Statforvalteren i Vestfold og telemark"
                    url="/logo-vestfold-og-telemark"
                  />
                  <LinkListItem
                    title="Statforvalteren i Vestland"
                    url="/logo-vestland"
                  />
                </ListGroup>
              </Col>
            </Row>
            <DoDont
              doTag="Vi skriver:"
              doText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
              dontTag="Vi skriver ikke:"
              dontText="Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in. "
            />

            <FeaturedBlock
              imageUrl="https://via.placeholder.com/600x400"
              title="Eksempel på anvendelse"
              lead="Mønsteret er fritt å benytte på ulike elementer, slik som T-skjorter, kopper, sekker, mapper m.m. NYHET: I motsetning til tidligere er det nå også tillatt å markere flaten med vår egen logo."
              linkText="Se flere eksempler på anvendelse"
              linkUrl="/"
            />

            <Row className="my-6">
              <Col lg={{ span: 10, offset: 1 }}>
                <Table responsive size="lg" className=" table-simple">
                  <ColorTableHead />
                  <tbody>
                    <ColorTableRow
                      colorCode="#00244E"
                      textColor="#ffffff"
                      colorName="Mørk lilla"
                      hex="#00244E"
                      rgb="(00,36,78)"
                      cmyk="100/70/0/64"
                      pms="295 C"
                    />

                    <ColorTableRow
                      colorCode="#ffffff"
                      borderColor="#00244E"
                      colorName="Hvit"
                      hex="#ffffff"
                      rgb="(255,255,255))"
                      cmyk="0/0/0/0"
                    />
                  </tbody>
                </Table>
              </Col>
            </Row>

            <Row className="my-6">
              <Col lg={{ span: 10, offset: 1 }}>
                <Table responsive size="lg" className="table-simple">
                  <TypoTableHead />
                  <tbody>
                    <TypoTableRow
                      tag={<h1>H1</h1>}
                      fontWeight="Bold"
                      lineHeight="1.2"
                      mobile="36px"
                      desktop="52px"
                    />
                    <TypoTableRow
                      tag={<h2>H2</h2>}
                      fontWeight="Bold"
                      lineHeight="1.2"
                      mobile="28px"
                      desktop="40px"
                    />
                    <TypoTableRow
                      tag={<h3>H3</h3>}
                      fontWeight="Bold"
                      lineHeight="1.2"
                      mobile="22px"
                      desktop="32px"
                    />
                    <TypoTableRow
                      tag={<h4>H4</h4>}
                      fontWeight="Bold"
                      lineHeight="1.2"
                      mobile="18px"
                      desktop="24px"
                    />
                    <TypoTableRow
                      tag={<h5>H5</h5>}
                      fontWeight="Bold"
                      lineHeight="1.2"
                      mobile="16px"
                      desktop="20px"
                    />
                    <TypoTableRow
                      tag={<h6>H6</h6>}
                      fontWeight="Bold"
                      lineHeight="1.2"
                      mobile="14px"
                      desktop="26px"
                    />
                    <TypoTableRow
                      tag={<p className="lead">Ingress</p>}
                      fontWeight="Regular"
                      lineHeight="1.5"
                      mobile="20px"
                      desktop="24px"
                    />
                    <TypoTableRow
                      tag={<p>Brødtekst</p>}
                      fontWeight="Regular"
                      lineHeight="1.5"
                      mobile="16px"
                      desktop="16px"
                    />
                    <TypoTableRow
                      tag={<div className="small">Liten tekst</div>}
                      fontWeight="Regular"
                      lineHeight="-"
                      mobile="14px"
                      desktop="14px"
                    />
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="my-6">
              <Col>
                <Table responsive size="lg" className="table-simple">
                  <LogoTableHead />
                  <tbody>
                  <LogoTableRow
                    logoUrl={LogoAgderPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Agder, bokmål"
                    text="Bokmål"
                    blackSvg={LogoAgderPrimaerBokmaalPositivSvg}
                    blackPng={LogoAgderPrimaerBokmaalPositivPng}
                    blackPdf={LogoAgderPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoAgderPrimaerBokmaalNegativSvg}
                    whitePng={LogoAgderPrimaerBokmaalNegativPng}
                    whitePdf={LogoAgderPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Agder, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoAgderPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoAgderPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoAgderPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoAgderPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoAgderPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoAgderPrimaerBokmaalEngelskNegativPdf}
                  />
                  </tbody>
                </Table>
              </Col>
            </Row>
          </main>
        </article>
      </Container>
    </>
  );
}
